// extracted by mini-css-extract-plugin
module.exports = {"img":"index_img__kN01i","error":"index_error__GAmsW"};